import { Box, Col, P, Reveal } from '@landsbankinn/ui-kit';
import { usePrismicContent } from './usePrismicContent';

export function PrismicContent() {
  const content = usePrismicContent();

  return (
    <>
      {content && content.ad ? (
        <Reveal
          show={true}
          initial={true}
          animationDuration={700}
          ease="easeIn"
          skipHeightAnimation
          startHeightAnimationAt={0}
        >
          <Col
            minHeight="580"
            minWidth="580"
            mainAxisAlignment="end"
            style={{
              backgroundImage: `url(${content.ad.imageUrl})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              cursor: content.ad.linkUrl ? 'pointer' : undefined,
            }}
            onClick={() => {
              if (content.ad.linkUrl) window.open(content.ad.linkUrl);
            }}
          >
            {content.ad.text && (
              <Box width="228" marginBottom="70" marginLeft="55">
                <P
                  color="common white"
                  fontSize="35"
                  fontFamily="LB Centro Serif Cond"
                  fontWeight="medium"
                  letterSpacing=".2"
                  lineHeight="43.52"
                >
                  {content.ad.text}
                </P>
              </Box>
            )}
          </Col>
        </Reveal>
      ) : (
        <Box minHeight="580" minWidth="580" />
      )}
    </>
  );
}
